<template>
    <div>
        <job-header-simple header_title="授信开票" left_text="" :part_background="true"></job-header-simple>
        <div class="header">
        </div>
        <div class="invoice-info">
            <div class="title">开票信息</div>
            <van-cell-group>
                <van-cell title="开票公司" :value="openInvoiceData.ecompanyName" />
                <van-cell title="用工类型" :value="openInvoiceData.typeName" />
                <van-cell title="发票类型" :value="openInvoiceData.invoiceType" />
                <van-cell title="发票内容" :value="openInvoiceData.contentName" />
                <!--<van-cell title="开票金额" :value="baseForm.receiptAmount" class="money"/>-->
                <van-field v-model="receiptTotalAmount" type="number" label="开票金额" input-align="right"
                           placeholder="请输入开票金额"/>
            </van-cell-group>
        </div>
        <div class="invoice-title">
            <div class="title">发票抬头</div>
            <van-cell-group>
                <van-cell title="发票抬头" :value="openInvoiceData.invoiceTitle" />
                <van-cell title="纳税人识别号" :value="baseForm.taxerCode" />
                <van-cell title="联系电话" :value="baseForm.ecompanyPhone" />
                <van-cell title="开户银行" :value="baseForm.bankName" />
                <van-cell title="银行账号" :value="baseForm.bankAccount" />
                <van-cell title="公司地址" :value="baseForm.ecompanyAddr"/>
            </van-cell-group>
        </div>
        <div class="receipt-info">
            <div class="title">收件信息</div>
            <van-cell-group>
                <van-cell title="收 件 人" :value="baseForm.receiveName" />
                <van-cell title="联系电话" :value="baseForm.receiveMobile" />
                <van-cell title="联系地址" :value="baseForm.receiveAddress" />
            </van-cell-group>
        </div>
        <div class="submit">
            <div class="cancel" @click="cancel">
                取消
            </div>
            <div class="confirm" @click="confirm">
                确认
            </div>
        </div>
    </div>
</template>
<script>
    import { Row,Col,Icon,Cell,Divider,CellGroup,Dialog,Field  } from "vant";
    import jobHeaderSimple from "@/components/header/header.vue";
    import api from "@/api/list";

    export default {
        components: {
            [Row.name]: Row,
            [Row.name]: Row,
            [Icon.name]: Icon,
            [Col.name]: Col,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Divider.name]: Divider,
            [Dialog.name]: Dialog,
            jobHeaderSimple
        },
        watch:{
            receiptTotalAmount:{
                handler:function(newV,oldV){
                    //只能输入小数点两位,超过时处理
                    let array = newV.toString().split(".");
                    let point = Array.from(array[1]?newV.toString().split(".")[1]:0);
                    let finalNum = '';
                    if (point.length>2) {
                        finalNum = array[0]+ '.' + point[0] + point[1];
                        this.receiptTotalAmount = parseFloat(finalNum);
                    }
                }
            }
        },
        created() {
            this.initData();
            this.getData();
        },
        data() {
            return {
                openInvoiceData:{},
                dataForm:{},
                baseForm:{},
                receiptTotalAmount:'',
                confirmLoading: false,
            };
        },
        methods: {
            initData(){
                // 申请开票页信息
                this.openInvoiceData = JSON.parse(sessionStorage.getItem("openInvoice"));
            },
            getData(){
                this.ecompanyId = this.$route.query.ecompanyId;
                api.getDefaultEcompanyReceipt({ecompanyId:this.ecompanyId}).then(res => {
                    if (res.data.status == "200") {
                        this.baseForm = res.data.data;
                        this.baseForm.receiptTotalAmount = "";
                        this.baseForm.id = "";
                    }
                });
            },
            confirm(){
                if(this.confirmLoading){
                    console.log('重复提交！')
                    return ;
                }
                this.baseForm.ecompanyId = this.$route.query.ecompanyId;
                this.baseForm.ocompanyId = this.$route.query.ocompanyId;
                this.baseForm.receiptContent = this.openInvoiceData.contentId;
                this.baseForm.receiptType = this.openInvoiceData.invoiceTypeId;
                this.baseForm.receiptTotalAmount = this.receiptTotalAmount;
                //开票金额检查
                if(this.baseForm.receiptTotalAmount==""||this.baseForm.receiptTotalAmount==undefined||this.baseForm.receiptTotalAmount==null){
                    this.$toast({
                        message: "请输入金额!",
                    });
                    return;
                }
                var reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/;
                if (!reg.test(this.baseForm.receiptTotalAmount)) {
                    this.$toast({
                        message: "请输入合法的金额数字，最多两位小数!",
                    });
                    this.receiptTotalAmount= "";
                    return;
                }
                if (this.baseForm) {
                    this.confirmLoading = true;
                    api.creditReceiptByPartner(this.baseForm,{ method: "post" }).then(res => {
                        if (res.data.status == "200") {
                            this.removeSession();
                            Dialog.confirm({
                                title:'提交成功',
                                confirmButtonText:'查看记录',
                                cancelButtonText:'返回首页'
                            })
                                .then(() => {
                                    this.$router.push("/invoice_records");
                                    this.confirmLoading = false;
                                })
                                .catch(() => {
                                    this.$router.push("/partner_index");
                                    this.confirmLoading = false;
                                });
                        }else {
                            this.$toast({
                                message: res.data.message,
                            });
                            this.confirmLoading = false;
                        }
                    });
                }else{
                    console.log('缺少参数')
                    this.confirmLoading = false;
                }
            },
            cancel(){
                this.$router.go(-1);
            },
            removeSession(){
                sessionStorage.removeItem('openInvoice');
                sessionStorage.removeItem('chooseInvoiceData');
            }
        }
    };
</script>

<style lang="less" scoped>
    .header{
        width: 100%;
        height: 3.46rem;
        background-color: #6275f0;
    }
    .invoice-info{
        width: 90%;
        min-height: 7.6rem;
        overflow-y: scroll;
        margin: -2.72rem auto 0;
        background-color: #ffffff;
        border-radius: 12px;
        position: relative;
        padding: 0.2rem;
        .title{
            font-size: 0.37rem;
            color: #6275f0;
            padding: 0.4rem 0.4rem;
        }
        /deep/ .van-cell__value{
            flex: 2;
        }
        .money{
            /deep/ .van-cell__value{
                color: #6275f0;
            }
        }
    }
    .invoice-title{
        width: 90%;
        min-height: 8.6rem;
        overflow-y: scroll;
        margin: 0.24rem auto 0;
        background-color: #ffffff;
        border-radius: 12px;
        position: relative;
        padding: 0.2rem;
        .title{
            font-size: 0.37rem;
            color: #6275f0;
            padding: 0.4rem 0.4rem;
        }
        /deep/ .van-cell__value{
            flex: 2;
        }
    }
    .receipt-info{
        width: 90%;
        min-height: 5rem;
        overflow-y: scroll;
        margin: 0.24rem auto 2rem;
        background-color: #ffffff;
        border-radius: 12px;
        position: relative;
        padding: 0.2rem;
        .title{
            font-size: 0.37rem;
            color: #6275f0;
            padding: 0.4rem 0.4rem;
        }
        /deep/ .van-cell__value{
            flex: 2;
        }
    }
    .submit{
        width: 100%;
        height: 1.49rem;
        background-color: white;
        font-size: 0.37rem;
        left: 0;
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 100;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .cancel{
            width: 4.27rem;
            height: 1.15rem;
            line-height: 1.15rem;
            text-align: center;
            background-color: #edefff;
            border-radius: 0.16rem;
            border: solid 0.03rem #a9b5fe;
            color: #a9b5fe;
            margin-left: 0.4rem;
        }
        .confirm{
            width: 4.27rem;
            height: 1.15rem;
            line-height: 1.15rem;
            text-align: center;
            background-color: #6275f0;
            border-radius: 0.16rem;
            color: #ffffff;
            margin-right: 0.4rem;
        }
    }
</style>